export class HydrationError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'HydrationError';
  }
}
